import { MessagePosition, MessageType } from '@epicuro-next/ataraxia/snack-bar';
import { createAction, props } from '@ngrx/store';

export { MessageType, MessagePosition };

export const showSnackBarMessage = createAction(
  '[Snackbar] Show message',
  props<{
    message: string;
    messageType: MessageType;
    position?: MessagePosition;
    actionName?: string;
    hideDelay?: number;
  }>(),
);
